
export async function createYoutubePlayer(element, youtubeId) {
  const youtubeApi = await loadVideoApi('https://www.youtube.com/iframe_api', 'YT')

  const api = {
    play: () => {},
    pause: () => {}
  }

  return new Promise((resolve) => {
    youtubeApi.ready(() => {
      // eslint-disable-next-line no-new
      new youtubeApi.Player(element, {
        videoId: youtubeId,
        width: 640,
        height: 390,
        host: 'https://www.youtube-nocookie.com',
        playerVars: {
          origin: window.location.host
        },
        events: {
          onReady: (event) => {
            api.play = () => event.target.playVideo()
            api.pause = () => event.target.pauseVideo()
            resolve(api)
          }
        }
      })
    })
  })
}

export async function createCloudflarePlayer(element, videoId, options = {}) {
  const useNativeLoop = options.loop && !options.maxLoops
  const params = new URLSearchParams({
    preload: 'metadata',
    ...(options.autoplay && { autoplay: 'true' }),
    ...(useNativeLoop && { loop: 'true' }),
    ...(options.muted && { muted: 'true' }),
    controls: 'false'
  })

  const iframe = document.createElement('iframe')
  iframe.src = `https://iframe.videodelivery.net/${videoId}?${params.toString()}`
  if (options.title) { iframe.setAttribute('title', options.title) }
  iframe.setAttribute('allow', 'accelerometer; gyroscope; autoplay; encrypted-media; picture-in-picture;')
  iframe.setAttribute('allowfullscreen', 'true')
  iframe.style.border = 'none'
  if (options.fill) {
    iframe.style.position = 'absolute'
    iframe.style.top = '50%'
    iframe.style.left = '50%'
    iframe.style.transform = 'translate(-50%, -50%)'
    iframe.style.width = '177.78vh' // 16/9 × 100vh
    iframe.style.height = '56.25vw' // 9/16 × 100vw
    iframe.style.minWidth = '100%'
    iframe.style.minHeight = '100%'
  } else {
    iframe.style.width = '100%'
    iframe.style.aspectRatio = '16 / 9'
  }
  element.appendChild(iframe)

  const Stream = await loadVideoApi('https://embed.cloudflarestream.com/embed/sdk.latest.js', 'Stream')
  const player = Stream(iframe)

  if (options.maxLoops) {
    let loopCount = 0
    player.addEventListener('ended', () => {
      loopCount++
      if (loopCount < options.maxLoops) {
        player.play()
      } else if (options.onLoopsComplete) {
        options.onLoopsComplete()
      }
    })
  }

  const api = {
    play: () => player.play(),
    pause: () => player.pause()
  }

  return Promise.resolve(api)
}

const loading = new Map()
export async function loadVideoApi(src, globalName) {
  const api = (window)[globalName]

  if(api) { return Promise.resolve(api) }

  const pending = loading.get(src)

  if(pending) { return pending }

  const promise = new Promise((resolve, reject) => {
    const scriptTag = document.createElement('script')
    scriptTag.src = src
    document.body.appendChild(scriptTag)
    scriptTag.onload = () => {
      resolve(window[globalName])
    }
    scriptTag.onerror = reject
  })
  loading.set(src, promise)

  return promise
}
